import { useQuery } from '@tanstack/react-query';
import { getAll } from '../services/getAllService';
import { unitExceptions } from '../utils/buildUnits';

const getUnitsReq = async () => {
  const {
    data: { unit },
  } = await getAll('unit');
  return unit?.filter(u => !unitExceptions.includes(u.label)) || [];
};

export const useUnits = () => {
  return useQuery({
    queryKey: ['units'],
    queryFn: () => getUnitsReq(),
    placeholderData: [],
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
